import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApplicationMenuService {
  public portfoliosToDisplay$ = new BehaviorSubject<{ portfoliosToDisplayIds: number[]; excludedProperties: number[] }>(
    {
      portfoliosToDisplayIds: null,
      excludedProperties: null,
    }
  );
  scrollEvent$ = new BehaviorSubject<Event>(null);
}
